import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format'
import { Input } from 'antd';
import { assign, get, includes } from 'lodash';
import moment from 'moment';

import YearlyReport from '../Yearly';
import readProductionJobs from './readProductionJobs';
import { lib } from 'src/Utils';
import staticProd from 'src/Utils/static/productionJobs'
import typeCodes from 'src/Utils/static/typeCodes';
import monthlyProdHelper from 'src/pages/DashboardApp/Reports/MonthlyProduction/helper';
import NumberColor from '../Yearly/NumberColor';
import InputExpenses from './InputExpenses';

class ManagementYearlyReport extends YearlyReport {
  constructor(props) {
    super(props)

    this.myProfile = lib.ls.getCurrentUser()

    this.title = "Management Yearly Report"
    this._expenses = null
    this._objExpenses = {}

    this.columns.unshift(...[
      {
        title: 'Production',
        children: [
          {
            title: 'NZD',
            dataIndex: ['amount'],
            align: 'right',
            width: 80,
            render: val => {
              if (!val) return '-'
              return (
                <NumberFormat
                  thousandSeparator
                  displayType='text'
                  value={Number(val).toFixed(2)}
                />
              )
            },
            // --------- summary ---------
            summaryKey: 'amount',
            renderSummary: (total, dataSource) => {
              return !total ? '-' : (
                <NumberFormat
                  thousandSeparator
                  displayType='text'
                  value={Number(total).toFixed(2)}
                />
              )
            },
          },
          {
            title: 'Rp',
            dataIndex: ['amount_rp'],
            align: 'right',
            width: 95,
            render: val => {
              if (!val) return '-'
              return (
                <NumberFormat
                  thousandSeparator
                  displayType='text'
                  value={Number(val).toFixed(0)}
                />
              )
            },
            // --------- summary ---------
            summaryKey: 'amount_rp',
            renderSummary: (total, dataSource) => {
              return !total ? '-' : (
                <NumberFormat
                  thousandSeparator
                  displayType='text'
                  value={Number(total).toFixed(0)}
                />
              )
            },
          },
        ],
      },
      {
        title: 'Expenses (Rp)',
        dataIndex: ['expenses'],
        align: 'right',
        width: 100,
        render: (val, record) => (
          <InputExpenses
            value={val}
            onSave={(value) => this.setExpenses(record.date, value)}
          />
        ),
        // --------- summary ---------
        summaryKey: 'expenses',
        renderSummary: (total, dataSource) => {
          return !total ? '-' : (
            <NumberFormat
              thousandSeparator
              displayType='text'
              value={total}
            />
          )
        },
      },
      {
        title: 'Reward',
        children: [
          {
            title: 'Rp',
            dataIndex: ['reward'],
            align: 'right',
            width: 95,
            render: (val, record) => {
              // jika if bonus ada disini, untuk menampilkan 1 tahun bagaimana
              if (!val) return '-'
              if (!this.getHasBonus(record.date, record.user)) return 'N/A'
              return (
                // <span title={`Reward $ : ${Number(record.rewardDollar).toFixed(2)}`}>
                  <NumberFormat
                    thousandSeparator
                    displayType='text'
                    title={`Reward : $ ${Number(record.rewardDollar).toFixed(2)}`}
                    value={val.toFixed(0)}
                  />
                // </span>
              )
            },
            // --------- summary ---------
            summaryKey: 'reward',
            renderSummary: (total, dataSource) => {
              return !total ? '-' : (
                <NumberFormat
                  thousandSeparator
                  displayType='text'
                  value={Number(total).toFixed(2)}
                />
              )
            },
          },
          {
            title: '%',
            dataIndex: ['rewardPct'],
            align: 'center',
            width: 50,
            render: (val) => !val
              ? '-'
              : <div style={{ textAlign: 'right' }}>
                {Math.floor(val * 100 * 10) / 10}
              </div>,
            // --------- summary ---------
            summaryKey: 'rewardPct',
            // summaryProps: { align: 'center' },
            renderSummary: (total, dataSource) => {
              const avg = total / dataSource.length
              return avg
                ? Math.floor(avg * 100 * 10) / 10
                : '-'
            },
          },
        ],
      },
      {
        title: 'Margin',
        children: [
          // ...(this.myProfile.email !== 'dev@onehub.net' ? [] : [
          {
            title: 'Rp',
            dataIndex: ['margin'],
            align: 'right',
            width: 95,
            render: (val) => !val ? '-' : (
              <NumberFormat
                thousandSeparator
                displayType='text'
                value={val.toFixed(0)}
              />
            ),
            // --------- summary ---------
            summaryKey: 'margin',
            renderSummary: (total, dataSource) => {
              return !total ? '-' : (
                <NumberFormat
                  thousandSeparator
                  displayType='text'
                  value={Number(total).toFixed(0)}
                />
              )
            },
          },
          // ]),
          {
            title: '%',
            dataIndex: ['marginPct'],
            align: 'right',
            width: 60,
            render: (val) => !val ? '-' : (
              <NumberFormat
                thousandSeparator
                displayType='text'
                // suffix=' %'
                value={val.toFixed(0)}
              />
            ),
            // --------- summary ---------
            summaryKey: 'marginPct',
            renderSummary: (total, dataSource) => {
              return !total ? '-' : (
                <NumberFormat
                  thousandSeparator
                  displayType='text'
                  suffix=' %'
                  value={(Number(total) / dataSource.length).toFixed(0)}
                />
              )
            },
          },
        ],
      },
    ])

    this.calculateColumnsWidth()
  }

  onRefInputExpenses = (ref) => {
    this._inputExpenses = ref
  }

  getHasBonus = (date, user) => {
    return !!(
      date &&
      get(user, 'start_bonus_date') &&
      moment(date).format('YYYY-MM') >= moment(user.start_bonus_date).format('YYYY-MM')
    )
  }

  getColumn = (dataIndex, columns = this.columns) => {
    for (const column of columns) {
      if (includes(column.dataIndex, dataIndex))
        return column

      let childColumn = null
      if (column.children)
        if (childColumn = this.getColumn(dataIndex, column.children))
          return childColumn
    }
  }

  readProductionJobs = async (opt) => {
    const resPointExchange = await monthlyProdHelper.readPointExchange(
      this.getParam('range_before'),
      this.getParam('range_after')
    )

    if (resPointExchange.errorResponse)
      return this.readFailed({ response: resPointExchange.errorResponse })
    else
      this._pointExchange = resPointExchange.pointExchange

    return readProductionJobs(opt)
  }

  convertAnotherResponseData = (_, dateMonth) => {
    const pointTypes = get(this._userTypes[dateMonth], [0, 'point_types'], [])
    // const pointTypeQS = pointTypes.find(type => typeCodes.QS_CODES.includes(type.code))

    const trainerType = pointTypes.find(type => typeCodes.TRAINER_CODES.includes(type.code))
    const managerType = pointTypes.find(type => typeCodes.MANAGER_CODES.includes(type.code))

    const qsExchangeFactor = get(pointTypes.find(type => typeCodes.QS_CODES.includes(type.code)), 'exchange_factor', staticProd.DEFAULT_EXCHANGE_FACTOR)
    const qaExchangeFactor = get(pointTypes.find(type => typeCodes.QA_CODES.includes(type.code)), 'exchange_factor', staticProd.DEFAULT_EXCHANGE_FACTOR)
    // const trainerExchangeFactor = get(pointTypes.find(type => typeCodes.TRAINER_CODES.includes(type.code)), 'exchange_factor', staticProd.DEFAULT_EXCHANGE_FACTOR)
    const trainerExchangeFactor = get(trainerType, 'exchange_factor', staticProd.DEFAULT_EXCHANGE_FACTOR)
    // const managerExchangeFactor = get(pointTypes.find(type => typeCodes.MANAGER_CODES.includes(type.code)), 'exchange_factor', staticProd.DEFAULT_EXCHANGE_FACTOR)
    const managerExchangeFactor = get(managerType, 'exchange_factor', staticProd.DEFAULT_EXCHANGE_FACTOR)

    const month = moment(dateMonth).format('YYYY-MM')
    const qsProductionJobs = get(this._productionJobs, ['objQs', month], [])
    const qaProductionJobs = get(this._productionJobs, ['objQa', month], [])
    // const amount = qsProductionJobs.reduce((acc, val) => acc + Number(val.qs_value), 0)
    let amount = 0, reward = 0, pointQS = 0, pointQA = 0, pointTrainer = 0, pointManager = 0
    for (const job of qsProductionJobs) {
      amount += Number(job.qs_value)

      if (qsExchangeFactor)
        pointQS += Number(job.qs_point)
    }

    for (const job of qaProductionJobs) {
      pointQA += Number(job.qa1_point)
    }

    if (trainerType)
      pointTrainer = trainerType.denominator

    if (managerType)
      pointManager = managerType.denominator

    const user = get(this._userTypes[dateMonth], [0])
    // if (lib.getHasBonus(user, strMonth)) {
    reward = (
      (pointQS * qsExchangeFactor) +
      (pointQA * qaExchangeFactor) +
      (pointTrainer * trainerExchangeFactor) +
      (pointManager * managerExchangeFactor)
    ) * this._pointExchange[month].rate

    const rewardDollar = (this.getHasBonus(dateMonth, user) && reward / this._pointExchange[month].rate) || 0

    const rewardPct = amount
      ? (rewardDollar / amount) || 0
      : 0

    console.log('here', { dateMonth, amount, reward, pointQS, pointQA, pointTrainer, pointManager, pointExchange: this._pointExchange, _productionJobs: this._productionJobs })

    return {
      amount,
      amount_rp: amount * this._pointExchange[moment(month).format('YYYY-MM')].rate,
      margin: this.calculateMargin({ date: month, amount, reward }),
      marginPct: this.calculateMarginPct({ date: month, amount, reward }),
      reward,
      rewardDollar,
      rewardPct,
      user,
    }
  }

  // renderSummaryTable = (currentData) => {
  //   const summary = {}
  //   let summaryKeys = []
  //   for (const column of this.columns) {
  //     summaryKeys.push(column.summaryKey)

  //     // hanya mendukung 1 child level
  //     for (const childColumn of (column.children || []))
  //       summaryKeys.push(childColumn.summaryKey)
  //   }
  //   summaryKeys = summaryKeys.filter(v => v)// = this.columns.map(column => column.summaryKey || (column.children)).filter(val => val)
  //   for (const record of currentData) {
  //     for (const summaryKey of summaryKeys) {
  //       summary[summaryKey] = (summary[summaryKey] || 0) + (record[summaryKey] || 0)
  //     }
  //   }

  //   console.log('renderSummaryTable', summary, currentData)

  //   const columns = this.columns.reduce((acc, column) =>
  //     acc.concat(...(column.children ? column.children : [column])), [])

  //   return (
  //     <Table.Summary>
  //       <Table.Summary.Row style={{ borderTop: '1px solid black' }}>
  //         {columns.map((column, i) => (
  //           <Table.Summary.Cell index={i} align="right" className="summary-cell-border" {...column.summaryProps}>
  //             {column.renderSummary && column.renderSummary(summary[column.summaryKey], currentData, summary)}
  //           </Table.Summary.Cell>
  //         ))}
  //       </Table.Summary.Row>
  //     </Table.Summary>
  //   )
  // }

  getExpenses = (date) =>
    this._objExpenses[moment(date).format('YYYY-MM')] ||
    this._expenses ||
    0

  setExpenses = (date, value) => {
    this._objExpenses[moment(date).format('YYYY-MM')] = Number(value) || 0
    this.recalculateMargin()
  }

  blurInput = () => {
    this._inputExpenses.input.blur()
    this.recalculateMargin()
  }

  calculateMargin = ({ date, amount, reward }) => !amount ? 0 : (
    (amount * this._pointExchange[moment(date).format('YYYY-MM')].rate) -
    (this.getExpenses(date) + reward)
  )

  calculateMarginPct = ({ date, amount, reward }) => (
    this.calculateMargin({ date, amount, reward }) /
    (amount * this._pointExchange[moment(date).format('YYYY-MM')].rate) *
    100
  )

  recalculateMargin = () => {
    this.updateList(
      this.__list.map(item => ({
        ...item,
        expenses: this.getExpenses(item.date),
        margin: this.calculateMargin({ date: item.date, amount: item.amount, reward: item.reward }),
        marginPct: this.calculateMarginPct({ date: item.date, amount: item.amount, reward: item.reward }),
      }))
    )
  }

  renderExtraTitle = () => (
    <Input
      ref={this.onRefInputExpenses}
      addonBefore="Expenses (Rp)"
      defaultValue={this._expenses}
      onChange={e => this._expenses = (Number(e.target.value) || 0)}
      onBlur={this.blurInput}
      onPressEnter={this.blurInput}
    />
  )
}

export default ManagementYearlyReport